<template>
    <div class="login">
        <div class="wrapper">
            <div class="title">Lite CRM</div>
            <img :src="logo" class="logo" style="width:211px;height:68px"/>
            <div class="content">
                <img :src="leftLogo" height="196" width="156" class="admin" />
                <el-form ref="form" :model="form" label-width="0" class="myForm" :rules="rules" :show-message="true" @keyup.enter.native="onSubmit('form')">
                    <el-form-item prop="name" :class="{'focus':focus.name}" >
                        <div @click="inputFocus('name')">
                            <el-input v-model="form.name"   @blur="inputBlur('name')" v-focus="focus.name"></el-input>
                            <span class="placeholder" @click="inputFocus('name')" :class="{'inner-empty':form.name==''}">邮箱</span>
                            <i class="el-icon-close" v-show="form.name!=''" @click="clearText('name')"></i>
                        </div>
                    </el-form-item>
                    <el-form-item prop="password" :class="{'focus':focus.password}" >
                        <div @click="inputFocus('password')">
                            <el-input type="password" v-model="form.password"  @blur="inputBlur('password')" v-focus="focus.password"></el-input>
                            <span class="placeholder" @click="inputFocus('password')" :class="{'inner-empty':form.password==''}">密码</span>
                            <i class="el-icon-close" v-show="form.password!=''" @click="clearText('password')"></i>
                        </div>
                    </el-form-item>
                    <el-form-item :class="{'focus':focus.code}" v-if="showCode" prop="code">
                        <el-row class="code-item">
                            <el-col :span="14">
                                <div  @click="inputFocus('code')">
                                    <el-input v-model="form.code"  @blur="inputBlur('code')" v-focus="focus.code"></el-input>
                                    <span class="placeholder" @click="inputFocus('code')" :class="{'inner-empty':form.code==''}">验证码</span>
                                    <i class="el-icon-close" v-show="form.code!=''" @click="clearText('code')"></i>
                                </div>
                            </el-col>
                            <img :src="imgSrc" @click="refreshImg" width="126px" height="48px" class="code-img" />
                        </el-row>
                    </el-form-item>
                </el-form>
                <el-button class="submit" :loading="loading" type="primary" @click="onSubmit('form')">{{loginText}}</el-button>
                <p class="forget" onclick="window.location.href='/butterfly/admin/sign-in/forgetPwd.html'">忘记密码?</p>
            </div>
        </div>
    </div>
</template>
<script>
import resource from '../common/resource';
import {requestPrefix} from '../common/resource';
import logo from '../../assets/images/login_logo.png'
import leftLogo from '../../assets/images/admin1.png'
const LOGIN_TXT = '登录';
export default {
    data() {
        
        var checkName = (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请输入邮箱')/*this.$message.error('请输入邮箱！')*/);
            } else if (!/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(value)) {
                callback(new Error('请输入正确的邮箱'));
            } else{
                return callback();
            }
        };
        var checkPassword = (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请输入密码')/*this.$message.error('请输入登录密码！')*/);
            }
            else{
                return callback();
            }
        };
        var checkCode = (rule, value, callback) => {
            if (!value) {
              return callback(new Error('请输入验证码')/*this.$message.error('请输入验证码！')*/);
            }
            else{
                return callback();
            }
        };
        return {
            logo:logo,
            leftLogo:leftLogo,
            form: {
                name: '',
                password: '',
                code: ''
            },
            focus: {
                name: false,
                password: false,
                code: false
            },
            showCode: false,
            loading: false,
            imgSrc: '',
            loginText: LOGIN_TXT,
            rules: {
              name: [
                { validator: checkName, trigger: 'blur,change' }
              ],
              password: [
                { validator: checkPassword, trigger: 'blur,change' }
              ],
              code: [
                { validator: checkCode, trigger: 'blur,change' }
              ]
            }
        }
    },
    directives: {
        focus: {
            inserted: function(el, binding) {
                if (binding.value) {
                    el.children[0].focus();
                }
            },
            update: function(el, binding) {
                if (binding.value&&(binding.oldValue!=binding.value)) {
                    el.children[0].focus();
                }
            }
        }
    },
    methods: {
        onSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.loginText = '';
                    var params = {
                        username: this.form.name,
                        password: this.form.password,
                        code: this.form.code
                    };
                    resource.user_signIn(params, null).then(response => {
                        if (response.body.success) {
                            window.location.href = '/butterfly/admin';
                        } else {
                            this.$message.error(response.body.message); //'邮箱或密码错误';
                            this.showCode = true;
                            this.form.code = '';
                            this.imgSrc = requestPrefix + '/captcha.png?' + new Date().getTime();
                            this.loading = false;
                            this.loginText = LOGIN_TXT;
                        }
                    }, response => {
                        this.loading = false;
                        this.loginText = LOGIN_TXT;
                        this.$message.error('邮箱或密码错误');
                        this.form.code = '';
                        this.imgSrc = requestPrefix + '/captcha.png?' + new Date().getTime();
                    });
                }else{
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        refreshImg () {
            this.imgSrc = requestPrefix + '/captcha.png?' + new Date().getTime();
        },
        inputFocus(arg) {
            for (var key in this.focus) {
                this.focus[key] = false;
            }
            this.focus[arg] = true;
        },
        inputBlur(arg) {
            if (this.form[arg] == '' || this.form[arg] == undefined) {
                this.focus[arg] = false;
            }
        },
        clearText(arg){
            this.form[arg]='';
        }
    }
}
</script>
<style lang="sass">
.login {
    height: 100%;
    background: url(../../assets/images/login-bg3.png) no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    .wrapper {
        .content{
            .admin{
                vertical-align: middle;
                display: inline-block;
                margin-right: 32px;
                margin-left: -8px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// index.vue?0b0a4c55